/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { PulseLoader } from 'react-spinners';
import { emailRegex } from '../../../assets/constants/strings';
import { forgotPass } from '../../../store/User/userActions';

const ResetPassword = ({ user, loading, forgotPass }) => {

  const [email, setEmail] = useState('');

  const [userNotFound, setUserNotFound] = useState(false);

  const [invalidData, setInvalidData] = useState(false);

  const handleResetPass = (e) => {
    e.preventDefault();
    if (!emailRegex(email)) {
      setInvalidData(true);
    } else {
      setInvalidData(false);
      forgotPass(email);
    }
  };

  useEffect(() => {
    setUserNotFound(!loading && user && user.sent === false && user.email === email);
  }, [user, loading, email]);

  return (
    <React.Fragment>
      <h2 className="mb-4 font-weight-bold">Password Reset</h2>
      <b>Resetting your password is easy. Just type in your registered email address to receive a password reset link.</b>

      <form onSubmit={handleResetPass} className="my-3" autoComplete="off">
        <div className="form-group mb-3">
          <input
            className={`form-control${(!loading && invalidData) || userNotFound ? ' is-invalid' : ''}`}
            placeholder="Email"
            type="email"
            id="Email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            required
          />
          {((!loading && invalidData) || userNotFound) && (
            <label id="EmailError" className="text-danger mt-1 mb-0">
              * {userNotFound ? user.reason : 'Invalid email formatting'}
            </label>
          )}
        </div>
        <button type="submit">Send Reset Password Email{loading ? <PulseLoader color={'#fff'} size={10} css="margin-left: 1rem" /> : null}</button>
      </form>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  loading: state.user.loading,
})

const mapDispatchToProps = { forgotPass };

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
